/*
* General custom scripts
**/
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';


/**
 * Processes loop items and wraps elements based on their structure.
 */
function processLoopItems() {
    document.querySelectorAll('.loop-item section').forEach(section => {
        let nextElement = section.nextElementSibling;
        while (nextElement && !nextElement.matches('section')) {
            nextElement.classList.add('fz-wrap__element');
            nextElement = nextElement.nextElementSibling;
        }

        const firstWrapElement = section.nextElementSibling;
        if (firstWrapElement && firstWrapElement.classList.contains('fz-wrap__element')) {
            firstWrapElement.classList.add('fz-wrap-container');

            const wrapper = document.createElement('section');
            wrapper.classList.add('classic-elements', 'container');
            const innerWrapper = document.createElement('div');
            innerWrapper.classList.add('classic-elements__inner', 'fz-wrap');

            wrapper.appendChild(innerWrapper);
            firstWrapElement.parentNode.insertBefore(wrapper, firstWrapElement);
            innerWrapper.appendChild(firstWrapElement);
        }
    });
}

/**
 * Moves elements into the proper classic-elements__inner container.
 */
function processClassicElements() {
    document.querySelectorAll('.classic-elements').forEach(classicElement => {
        let nextElement = classicElement.nextElementSibling;
        while (nextElement && !nextElement.matches('section')) {
            const toMove = nextElement;fooz
            nextElement = nextElement.nextElementSibling; // Move pointer before DOM manipulation
            classicElement.querySelector('.classic-elements__inner').appendChild(toMove);
        }
    });
}

/**
 * Sets up event handlers for popup interactions.
 */
function setupPopupHandlers() {
    document.querySelectorAll('.block-news-list .fz-button.fz-download-button').forEach(button => {
        button.addEventListener('click', handlePopup);
        button.addEventListener('tap', handlePopup);
    });

    document.querySelectorAll('.fz-button.fz-download-button').forEach(button => {
        button.addEventListener('click', handlePopupAlt);
        button.addEventListener('tap', handlePopupAlt);
    });

    document.querySelector('.popup-window .close-popup')?.addEventListener('click', closePopup);
    document.querySelector('.popup-window .close-popup')?.addEventListener('tap', closePopup);
}

/**
 * Opens the popup window with the correct link.
 */
function handlePopup(event) {
    const linkElement = event.currentTarget.closest('.fz-element.row')?.querySelector('.hidden-link');
    if (linkElement) {
        const link = linkElement.dataset.link;
        activatePopup(link);
    }
}

/**
 * Opens the popup window with an alternative button source.
 */
function handlePopupAlt(event) {
    const linkElement = event.currentTarget.closest('.buttons-outer')?.querySelector('.hidden-link');
    if (linkElement) {
        const link = linkElement.dataset.link;
        activatePopup(link);
    }
}

/**
 * Activates the popup window with the given link.
 */
function activatePopup(link) {
    const popup = document.querySelector('.popup-window');
    if (popup) {
        popup.setAttribute('data-link', link);
        popup.classList.add('active');
        document.body.classList.add('noscroll');
    }
}

/**
 * Closes the popup window.
 */
function closePopup() {
    const popup = document.querySelector('.popup-window');
    if (popup) {
        popup.classList.remove('active');
        popup.setAttribute('data-link', '');
        document.body.classList.remove('noscroll');
    }
}

//  POPUP MAIL SENT
const wpcf7WithPopup = document.querySelector('.popup-window .wpcf7');
if (typeof ( wpcf7WithPopup ) != 'undefined' && wpcf7WithPopup != null) {
    wpcf7WithPopup.addEventListener('wpcf7mailsent', function (){
        const file_id = jQuery('.popup-window').data('link');
        const url = phpvars.home_url + '/?download=' + file_id
        if (jQuery('body').hasClass('ios')) {
            window.location = url;
        } else {
            window.open(url);
        }
        jQuery('.popup-window').removeClass('active').attr('data-link', '');
        jQuery('html, body').toggleClass('noscroll');
        setTimeout(function (){
            jQuery('.wpcf7-form').removeClass('sent').addClass('init').attr('data-status', 'init');
            jQuery('.customCheckbox').prop('checked', false).removeClass('customCheckboxChecked');
        }, 1000);
    }, false);
}

// styling inputs
function materialDesignInputs (){

    ///scroll to anchor///
    jQuery(document).on('click', 'a[href^="#"]', function (event){
        event.preventDefault();
        let mainMenuHeight = jQuery('.page-header').outerHeight() || 0;
        let contentMenuHeight = jQuery('.block-content-menu').length > 0 ? jQuery(this).outerHeight() : 0;
        let finalHeight = mainMenuHeight + contentMenuHeight + 100;

        jQuery('html, body').animate({
            scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top - finalHeight
        }, 1000);
    });


    ////////////////////////////
    // material design inputs //
    ////////////////////////////
    var secPlaceholder;
    jQuery('.wpcf7-form input:not([type=\'checkbox\']), .wpcf7-form textarea').each(function (e){
        if (jQuery(this).attr('type') != 'file') {
            jQuery(this).wrap('<fieldset></fieldset>');

            if (jQuery(this).closest('div').find('.second-placeholder').length) {
                secPlaceholder = jQuery(this).closest('div').find('.second-placeholder').text();
                secPlaceholder = '<span class="second-placeholder-placed">' + secPlaceholder + '</span>';
                // console.log(secPlaceholder);
            } else {
                secPlaceholder = '';
            }

            var tag = jQuery(this).attr('placeholder');
            jQuery(this).attr('placeholder', '');
            jQuery(this).after('<label for="name">' + '<span>' + tag + '</span>' + secPlaceholder + '</label>');
        }
    });

    // input field file\
    if (jQuery('.wpcf7-form input[type="file"]').length > 0) {
        let pluscloseicon = '<span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="14px" height="14px" viewBox="0 0 14 14" style="enable-background:new 0 0 14 14;" xml:space="preserve"><defs></defs><path d="M14,1.41L12.59,0L7,5.59L1.41,0L0,1.41L5.59,7L0,12.59L1.41,14L7,8.41L12.59,14L14,12.59L8.41,7L14,1.41z"></path></svg></span>';

        let uploadInfo = jQuery('.file-upload-info').clone();
        jQuery('.file-upload-info').remove();
        jQuery('.file-upload-custom .wpcf7-form-control-wrap input').after(uploadInfo);

        jQuery('input[type="file"]').after('<span class="before-upload">Prześlij plik</span>');
        jQuery('input[type="file"]').after('<div class="button-main add-file"><span class="text">Przeglądaj</span><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17"><path id="Path_178" data-name="Path 178" d="M9,16h6V10h4L12,3,5,10H9ZM5,18H19v2H5Z" transform="translate(-5 -3)" fill="#fff"/></svg></span></div>');

        jQuery(document).on('click', '.add-file', function (event){
            jQuery(this).closest('.file-outer').find('input[type="file"]').click();
        });

        jQuery('input[type="file"]').change(function (e){
            let fileNameInput = e.target.files[ 0 ].name;
            let fileSizeInput = e.target.files[ 0 ].size;
            jQuery(this).after('<span class="clear-field file-action-button">' + pluscloseicon + '</span>');
            jQuery(this).after('<span class="uploaded-file-info"><span class="filename">' + fileNameInput + '</span><span class="filesize">' + bytesToSize(fileSizeInput) + '</span></span>');
            jQuery('.add-file').addClass('hide');
            jQuery('.file-upload-info').addClass('hide');
            jQuery('.file-upload-custom .wpcf7-form-control-wrap').addClass('file-uploaded');
            jQuery('.before-upload').addClass('hide');
        });
        jQuery(document).on('click', '.clear-field.file-action-button', function (event){
            jQuery('.file-upload-custom .wpcf7-form-control-wrap').removeClass('file-uploaded');
            jQuery('.add-file').removeClass('hide');
            jQuery('.file-upload-info').removeClass('hide');
            jQuery('input[type="file"]').val('');
            jQuery('.filename, .filesize').remove();
            jQuery('.clear-field.file-action-button').remove();
            jQuery('.before-upload').removeClass('hide');
        });
    }

    // menu remove href attributes
    jQuery('.page-header .menu-wrapper a').each(function (){
        if (jQuery(this).attr('href') == '#') {
            jQuery(this).removeAttr('href').addClass('menu-blank-link');
        }
    });

    // mobile menu open
    const clickHandler = ( 'touchend' in document.documentElement ? 'touchend' : 'click' );

    // jQuery(document).on(clickHandler, '#nav-icon3', function(event) {
    jQuery('#nav-icon3').on('click tap', function (event){
        if (jQuery(this).hasClass('open')) {
            jQuery('#hamburger-path-1').attr('d', 'M1.37,9.55h15.96');
            jQuery('#hamburger-path-2').attr('d', 'M14.63,2.42L8,2.42l-6.63,0');
            jQuery('#hamburger-path-3').attr('d', 'M1.37,16.69l5.16,0l5.16,0');
        } else {
            jQuery('#hamburger-path-1').attr('d', 'M8.18,9.55h2.25');
            jQuery('#hamburger-path-2').attr('d', 'M16.4,2.5L9.35,9.55L2.29,2.5');
            jQuery('#hamburger-path-3').attr('d', 'M2.29,16.61l7.05-7.05l7.05,7.05');
        }
        jQuery(this).toggleClass('open');
        jQuery(this).find('#special-hamburger').toggleClass('open');
        jQuery('.menu-wrapper').toggleClass('active');
        event.stopPropagation();
        jQuery('html, body').toggleClass('noscroll');
    });


    // open mobile menu submenu
    if (jQuery(window).width() < 921) {
        jQuery('.menu li span .fz-expand-wrapper, .menu-blank-link').on('click tap', function (event){
            if (jQuery(this).hasClass('megamenu-expand')) {
                // console.log('megamenu open');
                jQuery(this).closest('li').find('.fz-megamenu-container').first().slideToggle();
            } else {
                // console.log('menu li open');
                jQuery(this).closest('li').find('ul').first().slideToggle();
            }
            jQuery(this).closest('li').toggleClass('opened');

        });

    }


    jQuery('select').each(function (){
        var $this = jQuery(this),
            numberOfOptions = jQuery(this).children('option').length;

        var selected = '';
        if ($this.find('option:selected').val() != '')
            selected = 'selected';

        $this.addClass('select-hidden');
        $this.wrap('<div class="select" tabindex="0"></div>');
        $this.after('<div class="select-styled ' + selected + '"></div>');

        var $styledSelect = $this.next('div.select-styled');
        $styledSelect.text($this.find('option:selected').text());

        var $list = jQuery('<ul />', {
            'class': 'select-options'
        }).insertAfter($styledSelect);

        for (var i = 0; i < numberOfOptions; i++) {
            // if ($this.children('option').eq(i).val().length > 0) {
            jQuery('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
            }).appendTo($list);
            //}
        }

        var $listItems = $list.children('li');

        //hit enter
        jQuery('.select').keypress(function (e){
            var key = e.which;
            // console.log('keypress');
            if (key == 13)  // the enter key code
            {
                // console.log('keypress-enter');
                $styledSelect.click();
                jQuery('.select-options li').attr('tabindex', '0');
                return false;a
            }
        });

        $styledSelect.click(function (e){
            e.stopPropagation();
            jQuery('div.select-styled.active').not(this).each(function (){
                jQuery(this).removeClass('active').next('ul.select-options').hide();
            });
            jQuery(this).toggleClass('active').next('ul.select-options').slideToggle();
            // console.log('slide');

            if (jQuery(this).hasClass('active')) {
                var posBody = jQuery('body').scrollTop();
                var posHtml = jQuery('html').scrollTop();

                var posPage = 0;
                if (posBody > 0)
                    posPage = posBody;
                if (posHtml > 0)
                    posPage = posHtml;

                var posMin = ( jQuery(this).offset().top - posPage ) + jQuery(this).height() + jQuery(this).next('ul.select-options').height()

                if (posMin > jQuery(window).height()) {
                    var posPageDelta = posPage + ( posMin - jQuery(window).height() ) + 40;

                    jQuery('html, body').animate({
                        scrollTop: posPageDelta
                    }, 500);

                }
            }
        });

        //hit enter
        jQuery('.select-options li').keypress(function (e){
            var key = e.which;
            // console.log('keypress');
            if (key == 13)  // the enter key code
            {
                // console.log('keypress-enter');
                jQuery(this).click();
                return false;
            }
        });

        $listItems.click(function (e){
            e.stopPropagation();
            $styledSelect.text(jQuery(this).text()).removeClass('active').addClass('selected');
            $this.val(jQuery(this).attr('rel')).trigger('change').attr('selected');
            $this.trigger('change');
            $list.hide();
        });

        jQuery(document).click(function (){
            $styledSelect.removeClass('active');
            $list.hide();
        });
        var svg = '<div class="arrow"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="19.8px" height="11.67px" viewBox="0 0 19.8 11.67" style="enable-background:new 0 0 19.8 11.67;" xml:space="preserve"> <style type="text/css"> .st0{fill:#0099CD;}</style><defs></defs><polygon class="st0" points="18.03,0 9.9,8.13 1.77,0 0,1.77 9.9,11.67 19.8,1.77 "/></svg></div>'
        jQuery('.select').prepend(svg);
    });


}


/**
 * Initializes individual WPCF7 forms by adding validation tracking and loaders.
 */
function setupWPCF7Forms() {
    document.querySelectorAll('.wpcf7').forEach(wpcf7Element => {
        const loaderWrapper = wpcf7Element.querySelector('.loader-wrapper');
        const submitButton = wpcf7Element.querySelector('.wpcf7-submit');
        const validationInputHidden = wpcf7Element.querySelector('input[name="valid_form_scroll"]');

        if (validationInputHidden) {
            trackMouseMovement(validationInputHidden);
        }

        if (submitButton) {
            submitButton.addEventListener('click', () => {
                if (loaderWrapper) loaderWrapper.classList.add('loader-visible');
                submitButton.classList.add('fz-button-inactive');
            });
        }
    });
}

/**
 * Tracks mouse movement and updates a hidden input field with total distance traveled.
 */
function trackMouseMovement(validationInput) {
    let lastPosition = null;
    let totalDistanceTraveled = 0;

    document.body.addEventListener('mousemove', (e) => {
        if (lastPosition !== null) {
            const dx = e.clientX - lastPosition.x;
            const dy = e.clientY - lastPosition.y;
            totalDistanceTraveled += Math.sqrt(dx * dx + dy * dy);
        }
        lastPosition = { x: e.clientX, y: e.clientY };
        validationInput.value = Math.floor(totalDistanceTraveled);
    });
}

/**
 * Sets up global WPCF7 events to handle form submission states.
 */
function setupWPCF7GlobalEvents() {
    document.addEventListener('wpcf7invalid', resetLoader);
    document.addEventListener('wpcf7mailfailed', resetLoader);
    document.addEventListener('wpcf7spam', resetLoader);

    document.addEventListener('wpcf7mailsent', (event) => {
        resetLoader(event);

        // Reset checkboxes after form submission
        event.target.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
            checkbox.checked = false;
        });

        // Reset custom checkboxes
        event.target.querySelectorAll('.customCheckbox').forEach(checkbox => {
            checkbox.classList.remove('customCheckboxChecked');
        });
    });

    document.addEventListener('wpcf7submit', (event) => {
        const form = event.target;
        const loaderWrapper = form.querySelector('.loader-wrapper');
        const submitButton = form.querySelector('.wpcf7-submit');

        if (loaderWrapper) loaderWrapper.classList.add('loader-visible');
        if (submitButton) submitButton.classList.add('fz-button-inactive');
    });
}

/**
 * Resets loader and submit button state after a delay.
 */
function resetLoader(event) {
    const form = event.target;
    const loaderWrapper = form.querySelector('.loader-wrapper');
    const submitButton = form.querySelector('.wpcf7-submit');

    setTimeout(() => {
        if (loaderWrapper) loaderWrapper.classList.remove('loader-visible');
        if (submitButton) submitButton.classList.remove('fz-button-inactive');
    }, 1000);
}

/**
 * Adds validation for email fields to prevent consecutive dots before '@'.
 */
function validateEmailFields() {
    const emailFields = document.querySelectorAll('input[type="email"]');

    emailFields.forEach(emailField => {
        emailField.addEventListener('blur', handleEmailValidation);
    });
}

/**
 * Handles email validation for incorrect consecutive dots before '@'.
 */
function handleEmailValidation() {
    const emailParts = this.value.split('@');

    if (emailParts[0].includes('..')) {
        this.setCustomValidity('Email nie może zawierać dwóch kropek obok siebie przed znakiem @.');
    } else {
        this.setCustomValidity('');
    }

    this.reportValidity();
}

function restrictTelInput(e) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (!e.key.match(/[0-9]/) && !allowedKeys.includes(e.key)) {
        e.preventDefault();
    }
}

/**
 * Adds number-only restriction to telephone fields.
 */
function validateTelField() {
    const telField = document.querySelector('.wpcf7 input[type="tel"]');

    if (telField) {
        telField.addEventListener('keypress', restrictTelInput);
    }
}


/**
 * Styles checkboxes by wrapping them in a custom structure.
 */
function styleCustomCheckboxes() {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');

    checkboxes.forEach(checkbox => {
        // Create wrapper for the checkbox
        const wrapper = document.createElement('div');
        wrapper.classList.add('customCheckbox');
        wrapper.tabIndex = 0;

        // Create span element for styling
        const span = document.createElement('span');

        // Insert wrapper before checkbox and move elements inside
        checkbox.parentNode.insertBefore(wrapper, checkbox);
        wrapper.appendChild(span);
        wrapper.appendChild(checkbox);

        // Set tabindex for accessibility
        checkbox.tabIndex = -1;

        // Handle checkbox state change
        checkbox.addEventListener('change', function () {
            wrapper.classList.toggle('customCheckboxChecked', this.checked);
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    validateEmailFields();
    validateTelField();
    styleCustomCheckboxes();
    materialDesignInputs();
    setupWPCF7Forms();
    setupWPCF7GlobalEvents();
    processLoopItems();
    processClassicElements();
    setupPopupHandlers();
});

